var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiBasSparkleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_18761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9053 0C10.9053 4.99575 14.9583 9.04478 19.959 9.04492V10.8936C14.9583 10.8937 10.9053 14.9437 10.9053 19.9395H9.15723C9.15723 14.9436 5.10429 10.8936 0.103516 10.8936V9.04492C5.10429 9.04492 9.15723 4.99583 9.15723 0H10.9053Z",
    fill: "url(#paint0_linear_174_18761)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_174_18761",
    x1: 19.959,
    y1: 9.96973,
    x2: 0.103516,
    y2: 9.96973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE02A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B14EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_18761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBasSparkleIcon);
export default __webpack_public_path__ + "static/media/ai_bas_sparkle_icon.06a476a414e9d8757052bbb7e7cf969f.svg";
export { ForwardRef as ReactComponent };